"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OffpeakLegacy = void 0;
var react_1 = __importDefault(require("react"));
var OffpeakLegacy = function (props) { return (react_1.default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" }, props),
    react_1.default.createElement("path", { d: "M8.86 5.72A7.94 7.94 0 0111 .22a8.06 8.06 0 00-9.17 4.54 8 8 0 002.81 9.84 8 8 0 0010.23-1 9.37 9.37 0 01-3.26-1.92 8.18 8.18 0 01-2.75-5.96z", fill: "currentColor" }))); };
exports.OffpeakLegacy = OffpeakLegacy;
